module.exports = __webpack_public_path__ + "static/media/counted-logo-tagline-r.33e82de3.svg";